function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query getAccount(\n    $where: Accounts_bool_exp\n    $whereInstances: Instances_bool_exp\n    $whereWorkspaces: Workspaces_bool_exp\n    $withAccount: Boolean! = true\n    $withUsage: Boolean! = true\n  ) {\n    Accounts(limit: 1, where: $where) @include(if: $withAccount) {\n      can_publish_products\n      is_banned\n      NextTierId {\n        id\n        name\n      }\n      Tier {\n        name\n        id\n        TierLimits {\n          name\n          value\n          usage_type\n        }\n      }\n    }\n    Workspaces_count: Workspaces_aggregate(where: $whereWorkspaces)\n      @include(if: $withUsage) {\n      aggregate {\n        count\n      }\n    }\n    Instances_count: Instances_aggregate(where: $whereInstances)\n      @include(if: $withUsage) {\n      aggregate {\n        count\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { gql } from "graphql-request";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../config";
import { addInstance, addWorkspace, deleteInstance, deleteWorkspace, setCurrentAccount } from "../modules";
import { getAccountId } from "../utils";
import { TIER_HEADERS } from "../utils/tiers";
import { useAuth } from "./useAuth";
import { useQuery } from "./useGraphQLApi";
import { useRestApi } from "./useRestApi";
import { useValidSession } from "./useValidSession";
var GET_ACCOUNT_WITH_USAGE_QUERY = gql(_templateObject());
var useAppSelector = useSelector;
var useAppDispatch = function() {
    return useDispatch();
};
export var useUpdateCurrentAccount = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_withAccount = _ref.withAccount, withAccount = _ref_withAccount === void 0 ? true : _ref_withAccount, _ref_withUsage = _ref.withUsage, withUsage = _ref_withUsage === void 0 ? true : _ref_withUsage;
    var dispatch = useAppDispatch();
    var accountId = useAuth().accountId;
    var isAuthenticated = useValidSession();
    var skip = !(isAuthenticated && accountId);
    var _useQuery = useQuery(GET_ACCOUNT_WITH_USAGE_QUERY, {
        includeFields: {
            withAccount: withAccount,
            withUsage: withUsage
        },
        where: {
            api_key: {
                _eq: String(accountId)
            }
        },
        whereInstances: {
            Project: {
                api_account_id: {
                    _eq: String(accountId)
                }
            },
            deleted: {
                _eq: false
            }
        },
        whereWorkspaces: {
            deleted_at: {
                _is_null: true
            },
            owner: {
                _eq: String(accountId)
            }
        }
    }, {
        skip: skip
    }), data = _useQuery.data, error = _useQuery.error, isValidating = _useQuery.isValidating, mutate = _useQuery.mutate;
    useEffect(function() {
        if (isAuthenticated && accountId && skip) {
            mutate();
        }
    }, [
        accountId,
        isAuthenticated,
        skip,
        mutate
    ]);
    useEffect(function() {
        var _data_Accounts;
        var userData = {};
        if (withAccount && (data === null || data === void 0 ? void 0 : (_data_Accounts = data.Accounts) === null || _data_Accounts === void 0 ? void 0 : _data_Accounts.length)) {
            var _data_Accounts_ = data.Accounts[0], can_publish_products = _data_Accounts_.can_publish_products, is_banned = _data_Accounts_.is_banned, NextTierId = _data_Accounts_.NextTierId, Tier = _data_Accounts_.Tier;
            userData = {
                canPublishProducts: can_publish_products !== null && can_publish_products !== void 0 ? can_publish_products : false,
                isBanned: is_banned !== null && is_banned !== void 0 ? is_banned : false,
                nextTier: NextTierId ? {
                    id: NextTierId === null || NextTierId === void 0 ? void 0 : NextTierId.id,
                    name: NextTierId === null || NextTierId === void 0 ? void 0 : NextTierId.name
                } : null,
                tier: (Tier === null || Tier === void 0 ? void 0 : Tier.id) ? {
                    id: Tier.id,
                    limits: Tier.TierLimits.map(function(_param) {
                        var usage_type = _param.usage_type, params = _object_without_properties(_param, [
                            "usage_type"
                        ]);
                        return _object_spread_props(_object_spread({}, params), {
                            usageType: usage_type
                        });
                    }),
                    name: Tier.name
                } : null
            };
        }
        if (withUsage && typeof (data === null || data === void 0 ? void 0 : data.Workspaces_count) !== "undefined") {
            var _data_Instances_count_aggregate, _data_Instances_count, _data_Workspaces_count_aggregate;
            userData = _object_spread_props(_object_spread({}, userData), {
                usage: {
                    instances: ((_data_Instances_count = data.Instances_count) === null || _data_Instances_count === void 0 ? void 0 : (_data_Instances_count_aggregate = _data_Instances_count.aggregate) === null || _data_Instances_count_aggregate === void 0 ? void 0 : _data_Instances_count_aggregate.count) || 0,
                    workspaces: ((_data_Workspaces_count_aggregate = data.Workspaces_count.aggregate) === null || _data_Workspaces_count_aggregate === void 0 ? void 0 : _data_Workspaces_count_aggregate.count) || 0
                }
            });
        }
        if (Object.keys(userData).length) {
            dispatch(setCurrentAccount(userData));
        }
    }, [
        data,
        dispatch,
        withAccount,
        withUsage
    ]);
    return {
        error: error,
        loading: isValidating
    };
};
export var useCurrentAccount = function() {
    var _currentAccount_tier;
    var fetchApi = useRestApi().fetchApi;
    var dispatch = useAppDispatch();
    var currentAccount = useAppSelector(function(param) {
        var currentAccount = param.currentAccount;
        return currentAccount;
    });
    var _currentAccount_usage = currentAccount.usage, instances = _currentAccount_usage.instances, workspaces = _currentAccount_usage.workspaces;
    var limits = (_currentAccount_tier = currentAccount.tier) === null || _currentAccount_tier === void 0 ? void 0 : _currentAccount_tier.limits;
    var getLimit = useCallback(function(limitHeader) {
        var _limits_find;
        var _limits_find_value;
        return parseInt((_limits_find_value = limits === null || limits === void 0 ? void 0 : (_limits_find = limits.find(function(param) {
            var name = param.name;
            return name === limitHeader;
        })) === null || _limits_find === void 0 ? void 0 : _limits_find.value) !== null && _limits_find_value !== void 0 ? _limits_find_value : Number.MAX_SAFE_INTEGER.toString());
    }, [
        limits
    ]);
    var changeOwnTier = function() {
        var _ref = _async_to_generator(function(tierId, tierName) {
            var result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchApi([
                                "".concat(config.subscriptionApiUrl, "/subscribe"),
                                {
                                    body: {
                                        api_key: getAccountId(),
                                        tier_id: tierId
                                    }
                                }
                            ])
                        ];
                    case 1:
                        result = _state.sent();
                        dispatch(setCurrentAccount(_object_spread_props(_object_spread({}, currentAccount), {
                            nextTier: {
                                id: tierId,
                                name: tierName
                            }
                        })));
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function changeOwnTier(tierId, tierName) {
            return _ref.apply(this, arguments);
        };
    }();
    var incInstancesCount = useCallback(function() {
        if (instances < getLimit(TIER_HEADERS.deploymentInstances)) {
            dispatch(addInstance());
        }
    }, [
        dispatch,
        getLimit,
        instances
    ]);
    var decInstancesCount = useCallback(function() {
        dispatch(deleteInstance());
    }, [
        dispatch
    ]);
    var incWorkspacesCount = useCallback(function() {
        if (workspaces < getLimit(TIER_HEADERS.marketplaceWorkspaces)) {
            dispatch(addWorkspace());
        }
    }, [
        dispatch,
        getLimit,
        workspaces
    ]);
    var decWorkspacesCount = useCallback(function() {
        dispatch(deleteWorkspace());
    }, [
        dispatch
    ]);
    var getCurrentLimits = useCallback(function() {
        var calculateLimitData = function(limit, usage) {
            return {
                limit: limit,
                reaching: limit - 1 <= usage,
                usage: usage
            };
        };
        return {
            instances: calculateLimitData(getLimit(TIER_HEADERS.deploymentInstances), instances),
            workspaces: calculateLimitData(getLimit(TIER_HEADERS.marketplaceWorkspaces), workspaces)
        };
    }, [
        getLimit,
        instances,
        workspaces
    ]);
    return _object_spread_props(_object_spread({}, currentAccount), {
        changeOwnTier: changeOwnTier,
        decInstancesCount: decInstancesCount,
        decWorkspacesCount: decWorkspacesCount,
        getCurrentLimits: getCurrentLimits,
        incInstancesCount: incInstancesCount,
        incWorkspacesCount: incWorkspacesCount
    });
};

//# sourceMappingURL=useCurrentAccount.js.map